import { useMemo, useState } from 'react'

import OverlayScrollbar from 'common/components/OverlayScrollBar'
import { formatWithCommasOrExponential } from 'common/utils/chart/chartUtils'

import type {
  IWisDetailsModalRoutesListProps,
  IWisDetailsModalRoutesList,
  IWisDetailsModalRoutesListTogglerProps
} from './types'

export const WisDetailsModalRoutesListToggler = ({
  remainingRoutes,
  displayKey,
  setDisplayKey
}: IWisDetailsModalRoutesListTogglerProps) => {
  if (remainingRoutes.length) {
    const showMoreTerm = displayKey === 'top5Routes'
    const term = showMoreTerm ? 'more' : 'less'
    const state: typeof displayKey = showMoreTerm ? 'allRoutes' : 'top5Routes'

    return (
      <div>
        <button
          className='text-lighthouseBlue cursor-pointer text-sm'
          onClick={() => {
            setDisplayKey(state)
          }}
          onKeyDown={(event) => {
            ;(event.key === 'Space' || event.key === 'Enter') &&
              setDisplayKey(state)
          }}
        >
          Show {remainingRoutes.length} {term}
        </button>
      </div>
    )
  }

  return null
}

export const WisDetailsModalRoutesList = ({
  routes
}: IWisDetailsModalRoutesListProps) => {
  const [displayKey, setDisplayKey] =
    useState<keyof IWisDetailsModalRoutesList>('top5Routes')

  const routesList = useMemo<IWisDetailsModalRoutesList>(() => {
    const allRoutes = routes.map((route, index) => (
      <div key={`${route.id}-${index}`}>
        {route.name}: {formatWithCommasOrExponential(route.fromMeasure, {isMeasure: true, isGraph: true})} ft - {formatWithCommasOrExponential(route.toMeasure, {isMeasure: true, isGraph: true})} ft
      </div>
    ))

    return {
      top5Routes: allRoutes.slice(0, 5),
      remainingRoutes: allRoutes.slice(5),
      allRoutes
    }
  }, [routes])

  return (
    <OverlayScrollbar scrollStyle='max-h-[120px]'>
      {routesList[displayKey]}
      <WisDetailsModalRoutesListToggler
        remainingRoutes={routesList.remainingRoutes}
        displayKey={displayKey}
        setDisplayKey={setDisplayKey}
      />
    </OverlayScrollbar>
  )
}

export default WisDetailsModalRoutesList
